import { Project } from 'src/core/models'
import { content } from './index'

/* Sections Array */
export const getProjectDetailsSection = (project: Project, isModalPreview: boolean) => [
  { // Description
    component: <content.ProjectDetailsDescription project={project}/>,
    isVisible: true
  },
  { // SDG Compliances
    component: <content.ProjectSdgDetailsList sdg_compliances={project.sdg_compliances} />,
    isVisible: project.sdg_compliances.length > 0
  },
  { // Project Information
    component: <content.ProjectDetailsInfoContent project={project} isModalPreview={isModalPreview}/>,
    isVisible: true
  },
  { // Fiscal Information
    component: <content.ProjectTaxReliefDetails project={project}/>,
    isVisible: true
  },
  { // Vintage Items
    component: <content.ProjectDetailsVintageItems project={project}/>,
    isVisible: project.is_vintage
  },
  { // Gallery
    component: <content.ProjectDetailsGallery project={project} />,
    isVisible: project?.cover || project?.main_image || project?.pictures?.length > 0
  },
  { // Video
    component: <content.ProjectDetailsVideo video={project?.video}/>,
    isVisible: project?.video
  },
  { // Certification
    component: <content.ProjectDetailsCertification project={project}/>,
    isVisible: !project.is_contribution_kind
  },
  { // Impacts
    component: <content.ProjectDetailsImpacts impacts={project.impacts}/>,
    isVisible: project?.has_impacts
  },
  { // Recent Purchases
    component: <content.ProjectDetailsRecentPurchases purchases={project.recent_purchases} />,
    isVisible: project?.recent_purchases?.length > 0
  }
]
